<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName }}</p>
    </div>
    <div class="outer-wrapper p-datatable mtn-header">
        <!--<div class="p-datatable-header"><span class="header-title">PLAN</span></div> -->
        <div *ngIf="showForm.planAccess" class="form-content">
            <form [formGroup]="forms.lineSubLineLovForm" class="form">
                <div class="form-container-grid top-form">
                    <div class="field required">
                        <label>Line</label>
                    </div>
                    <div class="">
                        <input formControlName="lineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('LINE')" [disabled]='btns.lov.lineDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Subline</label>
                    </div>
                    <div class="">
                        <input formControlName="subLineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('SUBLINE')" [disabled]='btns.lov.sublineDisabled'><mat-icon>search</mat-icon></button>
                    </div>

                    <div class="field required">
                        <label>Plan</label>
                    </div>
                    <div class="">
                        <input formControlName="planCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('PLAN')" [disabled]='btns.lov.planDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                </div>
            </form>
        </div>
        <osp-table [tblConfig]="tblConfig.planAccess" (onRowClick)="onRowClick.planAccess($event)"></osp-table>
        <div id="planAccess-maintenance-loading"><div class="form-loader"></div></div>
        <div *ngIf="showForm.planAccess" class="form-content">
            <form [formGroup]="forms.planAccessForm" class="form">
                <div id="planAccess-error-message"></div>
                <div class="form-container-grid">
                    <div class="field required">
                        <label>User Type</label>
                    </div>
                    <div class="">
                        <input formControlName="userTypeCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('USERTYPE')" [disabled]='btns.lov.userTypeDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field">
                        <label></label>
                    </div>
                    <div class="">
                    </div>
                    
                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input formControlName="lastUpdateUser" >
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input formControlName="lastUpdate" >
                    </div>
                </div>
            </form>
            <div class="btn-grp">
                <button class="btn btn2" type="button" (click)="onAdd.planAccess()" [disabled]="btns.planAccess.addDisabled" >ADD</button>
                <!-- <button *ngIf="!btns.paytOpt.updateDisabled" class="btn btn2" type="button" (click)="onUpdate.paytOpt()" >UPDATE</button> -->
                <button class="btn btn2" type="button" (click)="onDelete.planAccess()" [disabled]='btns.planAccess.deleteDisabled'>DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-grp">
                <button class="btn btn2" type="button" (click)="onSave.planAccess()" [disabled]='btns.planAccess.saveDisabled'>SAVE</button>
            </div>
        </div>
    </div>
</div>
